import { render } from "./justificativas.vue?vue&type=template&id=dd05e924"
import script from "./justificativas.vue?vue&type=script&lang=js"
export * from "./justificativas.vue?vue&type=script&lang=js"

import "./justificativas.vue?vue&type=style&index=0&id=dd05e924&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__